<template>
  <div class="ui warning icon message" v-if="storeStatus && storeStatus.warnings" >
    <i class="info circle icon"></i>
    <div class="content">
      <div class="header">
        Informācijai
      </div>
      <p>Daļa no precēm nav pievienotas Autoship, jo tās iespējams iegādāties tikai izmantojot standarta pasūtījumu:</p>
      <ul v-if="storeStatus.warnings && storeStatus.warnings.skipped_goods">
        <li v-for="item in storeStatus.warnings.skipped_goods"><b>{{item.goods_name}}</b></li>
       </ul>
    </div>
  </div>
</template>

<script>

export default {
    props: ['storeStatus'],

    deactivated: function() {
      //clear all warnings on page exit
      this.$store.commit('SET_CART_WARNINGS', false);
      this.$store.commit('SET_AUTOSHIP_WARNINGS', false);
    },
}
</script>



// WEBPACK FOOTER //
// SkippedGoodsWarning.vue?0e8b230b